import Layout from "components/layout";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "utilities/AuthGuard";
import "./App.css";
import UsersContainer from "pages/users/UsersContainer";
import NewDashboard from "pages/NewDashboard";
import Alarms from "pages/alarms/Alarms";
import TicketsContainer from "pages/tickets/TicketsContainer";
import Logs from "pages/Logs";
import HealthContainer from "pages/HealthCheck";
import Unity from "pages/unity";
import InAppUnity from "pages/InAppUnity";
import TagContainer from "pages/tags/TagContainer";
import ExpressionContainer from "pages/expressions/ExpressionContainer";
import AllAssets from "pages/all-assets/AllAssets";
import TempDashboard from "pages/Dashboard/temp";
import DashboardConfiguration from "components/shared/DashboardConfiguration/DashboardConfiguration";
import UnityLayout from "components/layout/UnityLayout";
import Watermark from "components/shared/Watermark/Watermark";

function App() {
  return (
    <>
      <Routes>
        <Route element={<AuthGuard />}>
          <Route element={<Layout />}>
            <Route path="/" element={<TempDashboard />} />
            <Route path="/unity" element={<InAppUnity />} />
            <Route path="/dashboard" element={<NewDashboard />} />
            <Route path="/dashboard-configuration">
              <Route element={<DashboardConfiguration />}>
                <Route
                  index
                  element={<Navigate to="/dashboard-configuration/tags" />}
                />
                <Route path="tags" element={<TagContainer />} />
                <Route path="expressions" element={<ExpressionContainer />} />
                <Route path="all-assets" element={<AllAssets />} />
              </Route>
            </Route>
            <Route path="/alarms" element={<Alarms />} />
            <Route path="/tickets" element={<TicketsContainer />} />
            <Route path="/users" element={<UsersContainer />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/health" element={<HealthContainer />} />
          </Route>
          <Route element={<UnityLayout />}>
            <Route path="/3d-exhibition" element={<Unity />} />
          </Route>
        </Route>
        <Route path="*" element={<p>Not Found</p>} />
      </Routes>
      <Watermark />
    </>
  );
}

export default App;
